import { initialize as g } from "launchdarkly-js-client-sdk";
let l = "";
function s(n) {
  const e = localStorage.getItem("ld:AnonymousDeveloperKey");
  if (!n && e === l)
    return {
      anonymous: !0,
      key: "ld-anon-developer"
    };
  if (!n)
    return {
      key: "ld-anon-user",
      anonymous: !0
    };
  const {
    id: i,
    school_id: o,
    district_id: a,
    roles: y,
    role: f
  } = n;
  return {
    key: `${i}`,
    custom: {
      schoolId: o,
      districtId: a,
      roles: y,
      role: f
    }
  };
}
let t;
const p = void 0;
async function w({
  clientId: n = process.env.VITE_LAUNCHDARKLY_CLIENT_ID,
  user: e = p,
  anonymousDeveloperKey: i = process.env.VITE_LAUNCHDARKLY_ANONYMOUS_DEVELOPER_KEY
} = {}) {
  return l = i || "", t || (t = g(n || "", s(e))), t;
}
async function c() {
  return t || await w();
}
let u = !1, r = [];
async function A() {
  if (!u)
    return new Promise((n) => r.push(n));
}
async function v(n) {
  const e = s(n), i = await c();
  await i.waitForInitialization();
  const o = await i.identify(e);
  return r.forEach((a) => a()), r = [], u = !0, o;
}
async function d(n, { user: e } = {}) {
  const i = await c();
  return await i.waitForInitialization(), e !== void 0 && await v(e), i.variation(n, !1);
}
const L = {
  install: (n) => {
    n.config.globalProperties.$getFlag = d;
  }
};
var D = /* @__PURE__ */ ((n) => (n.CCR = "licensing-ccr", n.LIVE_HELP = "licensing-live-help", n.PRACTICE = "licensing-practice", n.READING = "licensing-reading", n.WRITING = "licensing-writing", n))(D || {});
async function h(n) {
  return d(n);
}
export {
  D as LICENSING_KEY,
  L as VueLaunchDarkly,
  c as getClient,
  d as getFlag,
  h as getLicensing,
  s as getUserObject,
  v as identifyLaunchDarklyUser,
  w as initializeLaunchDarkly,
  A as waitForUserIdentification
};
